import React from "react";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { IconButton, Tooltip } from "@mui/material";

export const csvCell = (value) => {
    if (value == null) return "";
    const text = String(value);
    if (/[",\n\r]/.test(text)) {
        return `"${text.replace(/"/g, '""')}"`;
    }
    return text;
};

export const csvNumber = (value) => {
    const number = Number(value);
    return Number.isFinite(number) ? number : "";
};

export const downloadCsv = (filename, headers, rows) => {
    const lines = [headers, ...rows].map((row) => row.map(csvCell).join(","));
    const blob = new Blob([`\uFEFF${lines.join("\r\n")}`], { type: "text/csv;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
};

export function CsvDownloadButton({ label, disabled, onClick }) {
    return (
        <Tooltip title={disabled ? "No data to download" : "Download CSV"}>
            <span>
                <IconButton
                    aria-label={label}
                    disabled={disabled}
                    onClick={onClick}
                    size="small"
                    sx={{ flexShrink: 0 }}
                >
                    <FileDownloadOutlinedIcon />
                </IconButton>
            </span>
        </Tooltip>
    );
}
